module.exports = __webpack_public_path__ + "static/media/2C.94b4a5b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2C.svg
// module id = 53
// module chunks = 0